import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BodyContentItem } from '../../../shared-models';
import { WrittenContentLinkActionsUnion } from '../../listeners/written-content-anchor-click-listener';

@Component({
  selector: 'grid-ui-body-item',
  templateUrl: './body-item.component.html',
  styleUrls: ['./body-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BodyItemComponent {
  @Input() public bodyItem: BodyContentItem | null = null;
  @Input() public previousBodyItem: BodyContentItem | null = null;
  @Input() public enableNestedBodyItem = false;
  @Input() public tabName = '';
  @Output() public writtenContentLinkActionEmit = new EventEmitter<WrittenContentLinkActionsUnion>();
  @Output() public imageLoaded = new EventEmitter<void>();

  public emitWrittenContentLinkAction(action: WrittenContentLinkActionsUnion): void {
    this.writtenContentLinkActionEmit.emit(action);
  }

  public handleImageLoaded(): void {
    this.imageLoaded.emit();
  }

  public isConsecutiveH3(): boolean {
    return this.previousBodyItem?.type === 'heading';
  }
}
